var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"corp-snapshot"},[_vm._l((_vm.snapshotData.recent_remittance),function(option){return _c('card-in-home',{key:option.title,attrs:{"card-options":option}})}),_vm._l((_vm.snapshotData.total_remittance),function(option){return _c('card-in-home',{key:option.title,attrs:{"card-options":option}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }